import { UserPublicProfile } from '@features/public-profile/utils/models/public-profile.model';
import { Action, MetaReducer, createReducer } from '@ngrx/store';
import { HttpStateHandler } from '@shared/utils/classes/http-state-handler';
import { produceOn, transferStateMetaReducer } from '@shared/utils/functions/store.function';
import { HttpState } from '@shared/utils/models/http.model';
import { PublicProfileActions, PublicProfileResetActions } from '../actions/public-profile.actions';

export const publicProfileFeatureKey = 'publicProfile';

export interface State {
  slug: string | null;
  profile: UserPublicProfile | null;
  httpState: HttpState;
}

export const initialState: State = {
  slug: null,
  profile: null,
  httpState: HttpStateHandler.initialState,
};

export const publicProfileReducer = createReducer(
  initialState,
  produceOn(PublicProfileActions.getPublicProfile, (draft, action) => {
    draft.slug = action.slug;
    draft.profile = initialState.profile;
    draft.httpState = HttpStateHandler.loading(draft.httpState, action);
  }),
  produceOn(PublicProfileActions.getPublicProfileSuccess, (draft, action) => {
    const { themes, ...rest } = action.profile;
    draft.profile = {
      ...rest,
      themes: {
        ...themes,
        theme: {
          ...themes.theme,
          colors: JSON.parse(themes.theme.colors as unknown as string),
        },
      },
    };
    draft.httpState = HttpStateHandler.success(draft.httpState, action);
  }),
  produceOn(PublicProfileActions.getPublicProfileFailure, (draft, action) => {
    draft.httpState = HttpStateHandler.error(draft.httpState, action);
  }),
  produceOn(PublicProfileResetActions.cancelPublicProfileActionsSuccess, (draft) => {
    draft.httpState = HttpStateHandler.initialState;
  }),
  produceOn(PublicProfileResetActions.resetPublicProfile, (draft) => {
    draft.slug = initialState.slug;
    draft.profile = initialState.profile;
    draft.httpState = initialState.httpState;
  })
);

export function reducer(state: State | undefined, action: Action) {
  return publicProfileReducer(state, action);
}

export const metaReducers: MetaReducer<State>[] = [
  transferStateMetaReducer(publicProfileFeatureKey, initialState, false),
];
